import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DataList } from "@/components/common/DataList";
import { Pagination } from "@/components/common/Common";
import { useList } from "@/hooks/useList";
import { fmtDateTime } from "@/lib/api";

const COLLECTIONS = ["companies", "pte_companies", "people", "contracts", "users", "settings", "blocked_recipients", "super_funds", "job_positions", "job_locations"];
const EMAIL_STATUS = { sent: "bg-emerald-50 text-emerald-700 border-emerald-200", failed: "bg-red-50 text-red-700 border-red-200", blocked: "bg-slate-800 text-white border-slate-800" };

export function AuditTab() {
  const [coll, setColl] = useState("all");
  const list = useList("/admin/audit-log", { pageSize: 50, filters: coll !== "all" ? { collection_name: coll } : {} });
  const columns = [
    { key: "created_at", label: "When", render: (r) => fmtDateTime(r.created_at) },
    { key: "user_email", label: "User" },
    { key: "action", label: "Action", render: (r) => <span className="font-mono text-xs uppercase">{r.action}</span> },
    { key: "collection_name", label: "Collection" },
    { key: "record_id", label: "Record", render: (r) => <span className="font-mono text-xs">{r.record_id}</span> },
    { key: "changed_fields", label: "Fields", render: (r) => <span className="text-xs">{r.changed_fields.join(", ") || "—"}</span> },
  ];
  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <Select value={coll} onValueChange={setColl}>
          <SelectTrigger className="w-56 bg-white" data-testid="audit-collection-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All collections</SelectItem>{COLLECTIONS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <span className="text-xs text-slate-400">Audit entries are permanent and cannot be edited or deleted.</span>
      </div>
      <DataList columns={columns} rows={list.items} loading={list.loading} rowTestId="audit-row" mobileTitle={(r) => `${r.action} · ${r.collection_name}`} />
      <Pagination {...list} testId="audit-pagination" />
    </div>
  );
}

export function EmailLogTab() {
  const list = useList("/admin/email-log", { pageSize: 50 });
  const columns = [
    { key: "sent_at", label: "When", render: (r) => fmtDateTime(r.sent_at) },
    { key: "status", label: "Status", render: (r) => <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold border ${EMAIL_STATUS[r.status]}`} data-testid={`email-status-${r.id}`}>{r.status}</span> },
    { key: "subject", label: "Subject" },
    { key: "original_to", label: "Originally to", render: (r) => <span className="text-xs">{r.original_to.join(", ")}</span> },
    { key: "actual_to", label: "Actually sent to", render: (r) => <span className="text-xs">{r.actual_to.join(", ") || "—"}</span> },
    { key: "safe_mode", label: "Safe mode", render: (r) => (r.safe_mode ? "On" : "Off") },
    { key: "error", label: "Note", render: (r) => <span className="text-xs text-slate-500">{r.error || "—"}</span> },
  ];
  return (
    <div>
      <DataList columns={columns} rows={list.items} loading={list.loading} rowTestId="email-log-row" mobileTitle={(r) => r.subject} empty="No emails sent yet." />
      <Pagination {...list} testId="email-log-pagination" />
    </div>
  );
}
